export type ClassValue = string | false | null | undefined;

/** Joins truthy class names — the whole of our styling runtime. */
export function cx(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
